// tslint:disable: object-literal-key-quotes

export const fr = {
  translation: {
    // Global
    'Sure you want to delete': 'Etes-vous sûrs de vouloir supprimer',
    Yes: 'Oui',
    No: 'Non',
    Name: 'Nom',
    User: 'Utilisateur',
    Users: 'Utilisateurs',
    Organization: 'Organisation',
    Organizations: 'Organisations',
    Home: 'Accueil',
    informations: 'Informations',
    segment: 'Segments',
    organization_team: 'Organisation & équipe',
    team: 'Equipe',
    permissions_user: "Droit d'accès",
    role: 'Role',
    networks: 'Networks',
    customize_role_users: 'Personnaliser les roles utilisateurs',
    search_user: 'Rechercher un collaborateur par son prénom ou son nom',
    search_app: 'Rechercher une application',
    add_segment: 'Ajouter un segment',
    label: 'Label',
    url: 'Url',
    firstName: 'Prénom',
    lastName: 'Nom',
    new_job: 'Ajouter un nouveau job',
    new_role: 'Ajouter un role',
    new_org: 'Ajouter une organisation',
    email: 'Email',
    search_org: 'Rechercher une organisaton',

    // Forms
    'Access rights': "Droits d'accès",

    // Organizations
    'New organization': 'Nouvelle organisation',
    'Delete this organization ?': 'Supprimer cette organisation ?',
    'this organization': 'cette organisation',
    'Creating a new organization': "Création d'une nouvelle organisation",
    'Editing organization <strong>{{name}}</strong>':
      "Edition de l'organisation <strong>{{name}}</strong>",

    // Applications
    new_app: 'Nouvelle application',

    // Users
    new_user: 'Nouvel utilisateur',
    'Deleted this user ?': 'Supprimer cet utilisateur',
    'this user': 'cet utilisateur',
    'Creating a new user': "Création d'un nouvel utilisateur",
    'Editing user<strong>{{name}}</strong>':
      "Edition de l'utilisateur <strong>{{name}}</strong>",
    Role: 'Rôle',
    'First Name': 'Prénom',
    'Last Name': 'Nom de famille',

    phone: 'Téléphone',
    code: 'Entrez le code reçu par SMS',
    edit_profil: 'Modifier mon profil',
    password: 'Mot de passe',
    configure_auth: 'Configurer la double authentification',
    configure_auth_desc: 'L\'authentification à deux facteurs ajoute une couche supplémentaire de protection aux connexions. Une fois activé et configuré, chaque fois que vous vous connectez, il vous sera demandé de saisir votre nom d\'utilisateur, votre mot de passe et un code à deux facteurs.',
    double_auth: 'Double authentification',
    enable: 'activée',
    disabled: 'désactivée',
    update: 'Modifier',
    delete: 'Suprimer',
    validate: 'Valider',
    cancel: 'Retour',
    send: 'Envoyer',
    email_error: 'Format d\'email non valide',
  },
}
